<template>

  <div class="page">

    <div class="header">
      <div class="flex-row" style="justify-content: flex-end; width: 100%;">
        <div style="width: auto">选择版本：</div>
        <div style="width: auto;">
          <select>
            <option value="2021.02.25">2021.06.30</option>
          </select>
        </div>
      </div>
    </div>

    <br>

    <div class="content">

      <p style="text-align:center;">
        <span class="header-font-size">
          大参林隐私政策
        </span>
      </p>

      <br>

      <p>
        <span class="p-font-size">
          更新日期：2021年6月30日<br>
          生效日期：2021年6月30日
        </span>
      </p>


      <br>

      <p><span class="p-font-size"><strong>引言</strong></span></p>

      <p>
        <span class="p-font-size">
          1.感谢您选择使用大参林百科的服务。本隐私政策适用于大参林百科 App
          软件（统称为【大参林百科】）的大参林医药集团股份有限公司及其关联公司（以下简称「我们」），联系地址：广东省广州市荔湾区龙溪大道410号。更多大参林医药集团股份有限公司相关信息，可访问http://www.dslyy.com/了解。
        </span>
      </p>

      <p>
        <span class="p-font-size">
          2.您的个人信息安全对我们来说至关重要。一直以来，大参林百科都致力于为每位用户提供更安全的互联网环境。我们将依据《民法典》《网络安全法》《信息安全技术个人信息安全规范》（GB/T
          35273-2020）等法律法规和技术规范收集和使用您的个人信息，以帮助我们向您提供更优质的产品和/或服务。本隐私保护政策适用于大参林百科，请您务必认真阅读本隐私保护政策，确认充分了解并同意后使用大参林百科。我们承诺会对您的个人信息数据进行严格保密，并严格按照法律法规和本隐私保护政策，处理您的个人信息。
        </span>
      </p>

      <p><span class="p-font-size"><strong>特别提醒</strong></span></p>

      <p>
        <span class="p-font-size">
          请您仔细阅读本《隐私保护政策》（尤其是粗体内容），该政策解释我们如何收集、使用以及披露我们在服务中收到的信息。您使用服务即表示同意我们的《隐私保护政策》，即同意我们按照本《隐私保护政策》收集、使用、处理和存储您的相关信息。如果您不同意本《隐私保护政策》，请您立即注销账户以终止使用我们的产品和服务。
        </span>
      </p>

      <p>
        <span class="p-font-size">
          本政策将帮助您了解以下内容：<br>
          一、我们如何收集和使用您的用户信息<br>
          二、我们如何使用 Cookie 和同类技术<br>
          三、我们如何共享、转让、公开披露您的用户信息<br>
          四、我们如何保护您的用户信息<br>
          五、您的权利<br>
          六、本政策如何更新<br>
          七、如何联系我们<br>
          请在使用我们的产品（或服务）前，仔细阅读并了解本隐私政策。<br>
        </span>
      </p>

      <p><span class="p-font-size"><strong>一、我们如何收集和使用您的用户信息</strong></span></p>

      <p>
        <span class="p-font-size">
          （一）您使用我司产品或服务过程中我们收集和使用的信息
        </span>
      </p>

      <p>
        <span class="p-font-size">
          我们仅会出于本政策所述的业务功能，收集和使用您的用户信息，收集用户信息的目的在于向您提供产品或服务，您有权自行选择是否提供该信息，但多数情况下，如果您不提供，我们可能无法向您提供相应的服务，也无法回应您遇到的问题：
        </span>
      </p>

      <p>
        <span class="p-font-size">
          在您使用我们的服务时，允许我们收集您自行向我们提供的或为向您提供服务所必要的信息包括：网络日志、设备信息、位置信息和其它相关信息等。
        </span>
      </p>

      <p>
        <span class="p-font-size">
          对于我们收集的用户信息，我们将用于为您提供身份验证、安全防范、存档备份、服务优化等用途。
        </span>
      </p>

      <p>
        <span class="p-font-size">
          您提供的上述信息，将在您使用本服务期间持续授权我们使用。在您停止使用本服务时，我们将停止使用并删除上述信息。
        </span>
      </p>

      <p>
        <span class="p-font-size">
          我们保证会依法对收集后的用户信息进行去标识化或匿名化处理，对于无法单独或者与其他信息结合识别自然人个人身份的信息，不属于法律意义上的个人信息。如果我们将非个人信息与其他信息结合识别到您的个人身份时，或者与您的个人信息结合使用时，我们会在结合使用期间，将此类信息作为您的个人信息按照本隐私政策对其进行处理和保护。
        </span>
      </p>

      <p>
        <span class="p-font-size">
          为了更好运营和改善我们的技术和服务，或出于商业策略的变化，当我们提供的产品或服务所需的用户信息收集、使用、处理超出上述范围或者要将收集到的用户信息用于本隐私政策未载明的其他用途，或当我们要将基于特定目的收集而来的信息用于其他目的时，我们会在获取用户信息后的合理期限内或处理用户信息前通知您，并获得您的授权同意。
        </span>
      </p>

      <p>
        <span class="p-font-size">
          （二）征得授权同意的例外
        </span>
      </p>

      <p>
        <span class="p-font-size">
          请您理解，根据法律法规及相关国家标准，以下情形中，我们收集和使用您的用户信息无需征得您的授权同意：
        </span>
      </p>

      <p>
        <span class="p-font-size">
          1、与国家安全、国防安全直接相关的； <br>
          2、与公共安全、公共卫生、重大公共利益直接相关的；<br>
          3、与犯罪侦查、起诉、审判和判决执行等直接相关的；<br>
          4、出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；<br>
          5、所收集的您的用户信息是您自行向社会公众公开的；<br>
          6、从合法公开披露的信息中收集的您的用户信息，如合法的新闻报道、政府信息公开等渠道；<br>
          7、根据您的要求签订或履行合同所必需的；<br>
          8、用于维护软件及相关服务的安全稳定运行所必需的，例如发现、处置软件及相关服务的故障；<br>
          9、 个人信息控制者为新闻单位且其在开展合法的新闻报道所必需的；<br>
          10、学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的。<br>
          11、法律法规规定的其他情形。<br>
        </span>
      </p>

      <p><span class="p-font-size"><strong>二、我们如何使用 Cookie 和同类技术</strong></span></p>

      <p>
        <span class="p-font-size">
          （一）Cookie
        </span>
      </p>

      <p>
        <span class="p-font-size">
          为确保网站正常运转，我们会在您的计算机或移动设备上存储名为 Cookie 的小数据文件。Cookie 通常包含标识符、站点名称以及一些号码和字符。借助于 Cookie，网站能够存储您的访问偏好数据。
        </span>
      </p>

      <p>
        <span class="p-font-size">
          我们不会将 Cookie 用于本政策所述目的之外的任何用途。您可根据自己的偏好管理或删除 Cookie。您可以清除计算机上保存的所有 Cookie，大部分网络浏览器都设有阻止Cookie
          的功能。但如果您这么做，则需要在每一次访问我们的网站时亲自更改用户设置。
        </span>
      </p>

      <p>
        <span class="p-font-size">
          （二）网站信标和像素标签
        </span>
      </p>

      <p>
        <span class="p-font-size">
          除 Cookie 外，我们还会在网站上使用网站信标和像素标签等其他同类技术。例如，我们向您发送的电子邮件可能含有链接至我们网站内容的点击URL。
        </span>
      </p>

      <p>
        <span class="p-font-size">
          如果您点击该链接，我们则会跟踪此次点击，帮助我们了解您的产品或服务偏好并改善客户服务。网站信标通常是一种嵌入到网站或电子邮件中的透明图像。借助于电子邮件中的像素标签，我们能够获知电子邮件是否被打开。如果您不希望自己的活动以这种方式被追踪，则可以随时从我们的寄信名单中退订。
        </span>
      </p>

      <p>
        <span class="p-font-size">
          （三）Do Not Track（请勿追踪）
        </span>
      </p>

      <p>
        <span class="p-font-size">
          很多网络浏览器均设有Do Not Track功能，该功能可向网站发布Do Not Track请求。目前，主要互联网标准组织尚未设立相关政策来规定网站应如何应对此类请求。但如果您的浏览器启用了 Do Not
          Track，那么我们的所有网站都会尊重您的选择。
        </span>
      </p>

      <p><span class="p-font-size"><strong>三、我们如何共享、转让、公开披露您的用户信息</strong></span></p>

      <p>
        <span class="p-font-size">
          （一）共享
        </span>
      </p>

      <p>
        <span class="p-font-size">
          我们不会与其他的任何公司、组织和个人分享您的用户信息，但以下情况除外：
        </span>
      </p>

      <p>
        <span class="p-font-size">
          1、在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的用户信息。<br><br>
          2、我们可能会根据法律法规规定，或按政府主管部门的强制性要求，对外共享您的用户信息。<br><br>
          3、与我们的关联公司共享：您的用户信息可能会与我们的关联公司共享。我们只会共享必要的用户信息，且受本隐私政策中所声明目的的约束。关联公司如要改变用户信息的处理目的，将再次征求您的授权同意。<br><br>
          4、与授权合作伙伴共享：仅为实现本政策中声明的目的，我们的某些服务将由授权合作伙伴提供。我们可能会与合作伙伴共享您的某些用户信息，以提供更好的客户服务和用户体验。我们仅会出于合法、正当、必要、特定、明确的目的共享您的用户信息，并且只会共享提供服务所必要的用户信息。为了更好运营和改善技术和服务，您同意我们和授权合作伙伴在符合相关法律法规的前提下可将收集的信息用于其他服务和用途。<br><br>
        </span>
      </p>

      <p>
        <span class="p-font-size">
          以下列举了具体的授权合作伙伴，并提供了该第三方的隐私政策链接，我们建议您阅读该第三方的隐私政策：
        </span>
      </p>

      <p>
        <span class="p-font-size">
          （1）高德地图SDK，获取信息：位置信息、WIFI状态、网络状态，
          第三方隐私政策：https://lbs.amap.com/pages/privacy/；<br><br>
          （2）友盟SDK，获取信息：网络状态、Wifi状态、手机状态、读写存储空间，第三方隐私政策：https://www.umeng.com/policy；<br><br>
          （3）极光推送SDK，获取信息：IMEI，第三方隐私政策：https://www.jiguang.cn/license/privacy；<br><br>
          （4）微信分享SDK，获取信息：WIFI状态、手机状态、网络状态，第三方隐私政策：https://privacy.qq.com/policy/tencent-privacypolicy；<br><br>
          （5）华为推送SDK，获取信息：WIFI状态、手机状态、网络状态，第三方隐私政策：https://developer.huawei.com/consumer/cn/doc/start/<br>agreement-0000001052728169；<br><br>
          （6）小米推送SDK，获取信息：WIFI状态、手机状态、网络状态，第三方隐私政策：https://dev.mi.com/console/doc/detail?pId=1822。<br><br>
          （7）bugly SDK,获取信息: 日志信息,设备ID,网络状态,系统名称,系统版本,第三方隐私政策:
          https://static.bugly.qq.com/bugly-sdk-privacy-statement.pdf<br><br>
		  （8）百度文字识别OCR的SDK，获取信息：读取/写入外部存储卡，打开相机/摄像头，访问网络，第三方隐私政策：https://ai.baidu.com/ai-doc/REFERENCE/kk3dwjg7d<br><br>
		  （9）网易七鱼的SDK，获取信息：网络状态、wifi信息，IP地址络，第三方隐私政策：https://qi.163.com/termsService?privacy=1<br><br>
          （10）MSA移动安全联盟SDK，获取信息：设备制造商、设备型号、设备品牌，第三方隐私政策：http://www.msa-alliance.cn/col.jsp?id=122<br><br>
		  对我们与之共享用户信息的公司、组织和个人，我们会与其签署严格的保密协定，要求他们按照我们的说明、本隐私政策以及其他任何相关的保密和安全措施来处理用户信息。
        </span>
      </p>

      <p>
        <span class="p-font-size">
          （二）转让
        </span>
      </p>

      <p>
        <span class="p-font-size">
          我们不会将您的用户信息转让给任何公司、组织和个人，但以下情况除外：
        </span>
      </p>

      <p>
        <span class="p-font-size">
          1、在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的用户信息；<br><br>
          2、在涉及合并、收购或破产清算时，如涉及到用户信息转让，我们会再要求新的持有您用户信息的公司、组织继续受此隐私政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。
        </span>
      </p>

      <p>
        <span class="p-font-size">
          （三）公开披露
        </span>
      </p>

      <p>
        <span class="p-font-size">
          我们仅会在以下情况下，公开披露您的用户信息
        </span>
      </p>

      <p>
        <span class="p-font-size">
          1、获得您明确同意后；<br><br>
          2、基于法律的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的用户信息。
        </span>
      </p>

      <p>
        <span class="p-font-size">
          （四）共享、转让、公开披露信息时事先征得授权同意的例外
        </span>
      </p>

      <p>
        <span class="p-font-size">
          请您理解，根据法律法规及相关国家标准，以下情形中，我们共享、转让、公开披露您的用户信息无需征得您的授权同意：
        </span>
      </p>

      <p>
        <span class="p-font-size">
          1、与国家安全、国防安全直接相关的； <br><br>
          2、与公共安全、公共卫生、重大公共利益直接相关的； <br><br>
          3、与犯罪侦查、起诉、审判和判决执行等直接相关的； <br><br>
          4、出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的； <br><br>
          5、您自行向社会公众公开的信息； <br><br>
          6、从合法公开披露的信息中收集的，如合法的新闻报道、政府信息公开等渠道。
        </span>
      </p>

      <p><span class="p-font-size"><strong>四、我们如何保护您的用户信息</strong></span></p>

      <p>
        <span class="p-font-size">
          （一）我们已使用符合业界标准的安全防护措施保护您提供的用户信息，防止数据遭到未经授权的访问、公开披露、使用、修改、损坏或丢失。我们会采取一切合理可行的措施，保护您的用户信息。例如，在您的浏览器与“服务”之间交换数据时受
          SSL
          加密保护；我们同时对网站提供https安全浏览方式；我们会使用加密技术确保数据的保密性；我们会使用受信赖的保护机制防止数据遭到恶意攻击；我们会部署访问控制机制，确保只有授权人员才可访问用户信息；以及我们会举办安全和隐私保护培训课程，加强员工对于保护用户信息重要性的认识。
        </span>
      </p>

      <p>
        <span class="p-font-size">
          （二）我们会采取一切合理可行的措施，确保未收集无关的用户信息。我们只会在达成本政策所述目的所需的期限内保留您的用户信息，除非需要延长保留期或受到法律的允许。
        </span>
      </p>

      <p>
        <span class="p-font-size">
          （三）互联网并非绝对安全的环境，而且电子邮件、即时通讯、及与其他用户的交流方式并未加密，我们强烈建议您不要通过此类方式发送用户信息。
        </span>
      </p>

      <p>
        <span class="p-font-size">
          （四）互联网环境并非百分之百安全，我们将尽力确保您发送给我们的任何信息的安全性。即使我们做出了很大努力，采取了一切合理且必要的措施，仍然有可能无法杜绝您的用户信息被非法访问、被非法盗取，被非法篡改或毁坏，导致您的合法权益受损，请您理解信息网络的上述风险并自愿承担。
        </span>
      </p>

      <p>
        <span class="p-font-size">
          （五）在不幸发生用户信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知用户信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报用户信息安全事件的处置情况。
        </span>
      </p>

      <p><span class="p-font-size"><strong>五、您的权利</strong></span></p>

      <p>
        <span class="p-font-size">
          按照中国相关的法律、法规、标准，以及其他国家、地区的通行做法，我们保障您对自己的用户信息行使以下权利：
        </span>
      </p>

      <p>
        <span class="p-font-size">
          （一）访问您的用户信息<br><br>
          您有权访问您的用户信息，法律法规规定的例外情况除外。如果您想行使数据访问权，可以通过以下方式自行访问：<br><br>
          账户信息:您可以通过访问大参林百科->我的进行查看<br><br>
          如果您无法通过上述链接访问这些用户信息，您可以随时使用我们的 Web 表单联系，或发送电子邮件至dsl1999@dslyy.com。我们将在30天内回复您的访问请求。<br><br>
          对于您在使用我们的产品或服务过程中产生的其他用户信息，只要我们不需要过多投入，我们会向您提供。如果您想行使数据访问权，请发送电子邮件至dsl1999@dslyy.com。<br><br>
        </span>
      </p>

      <p>
        <span class="p-font-size">
          （二）更正您的用户信息<br><br>
          当您发现我们处理的关于您的用户信息有错误时，您有权要求我们作出更正。您可以通过“（一）访问您的用户信息”中罗列的方式提出更正申请。 如果您无法通过上述链接更正这些用户信息，您可以随时使用我们的 Web
          表单联系，或发送电子邮件至dsl1999@dslyy.com。我们将在30天内回复您的更正请求。
        </span>
      </p>

      <p>
        <span class="p-font-size">
          （三）删除您的用户信息<br><br>
          在以下情形中，您可以向我们提出删除用户信息的请求：<br><br>
          1、如果我们处理用户信息的行为违反法律法规；<br><br>
          2、如果我们收集、使用您的用户信息，却未征得您的同意；<br><br>
          3、如果我们处理用户信息的行为违反了与您的约定；<br><br>
          4、如果您不再使用我们的产品或服务，或您注销了账号；<br><br>
          5、如果我们不再为您提供产品或服务。<br><br>
          我们将会根据您的删除请求进行评估，若满足相应规定，我们将会采取相应步骤进行处理。当您向我们提出删除请求时，我们可能会要求您进行身份验证，以保障账户的安全。当您从我们的服务中删除信息后，因为适用的法律和安全技术，我们可能不会立即从备份系统中删除相应的信息，我们将安全存储您的信息直到备份可以清除或实现匿名化。
        </span>
      </p>

      <p>
        <span class="p-font-size">
          （四）改变您授权同意的范围<br><br>
          每个业务功能需要一些基本的用户信息才能得以完成（见本政策“第一部分”）。对于用户信息的收集和使用，您可以随时给予或收回您的授权同意。您可以通过本政策第八条的联系方式与我们联系进行授权变更。<br><br>
          当您收回同意后，我们将不再处理相应的用户信息。同时也请您注意，您撤销授权同意可能会导致某些后果，例如我们可能无法继续为您提供相应的服务或特定的功能，但您收回同意的决定，不会影响此前基于您的授权而开展的用户信息处理。
        </span>
      </p>

      <p>
        <span class="p-font-size">
          （五）用户信息主体注销账户 <br><br>
          您随时可注销此前注册的账户，您可以通过本政策第八条的联系方式与我们联系进行注销变更。<br><br>
          在注销账户之后，我们将停止为您提供产品或服务并依据您的要求，删除或匿名化您的信息，法律法规另有规定的除外。这也将可能导致您失去对您账户中数据的访问权，请您谨慎操作。
        </span>
      </p>

      <p>
        <span class="p-font-size">
          （六）用户信息主体获取用户信息副本<br><br>
          您有权获取您的用户信息副本，您可以通过本政策第八条的联系方式与我们联系获取用户信息副本。
        </span>
      </p>

      <p>
        <span class="p-font-size">
          七）约束信息系统自动决策<br><br>
          在某些业务功能中，我们可能仅依据信息系统、算法等在内的非人工自动决策机制作出决定。如果这些决定显著影响您的合法权益，您有权要求我们作出解释，我们也将提供适当的救济方式。
        </span>
      </p>

      <p>
        <span class="p-font-size">
          （八）响应您的上述请求<br><br>
          为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。<br><br>
          对于您合理的请求，我们原则上不收取费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际的请求，我们可能会予以拒绝。也请您理解，出于安全保障的考虑、相关法律法规的要求或技术上的限制，对于您的某些请求我们可能无法做出响应，例如以下情形：<br><br>
          1、与用户信息控制者履行法律法规规定的义务相关的；<br>
          2、与国家安全、国防安全直接相关的；<br>
          3、与公共安全、公共卫生、重大公共利益直接相关的；<br>
          4、与犯罪侦查、起诉、审判和执行判决等直接相关的；<br>
          5、用户信息控制者有充分证据表明用户信息主体存在主观恶意或滥用权利的；<br>
          6、出于维护用户信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；<br>
          7、响应用户信息主体的请求将导致用户信息主体或其他个人、组织的合法权益受到严重损害的；<br>
          8、涉及商业秘密的。
        </span>
      </p>

      <p><span class="p-font-size"><strong>六、未成年人的个人信息保护</strong></span></p>

      <p>
        <span class="p-font-size">
          1、本平台非常重视对未成年人个人信息的保护。若您是18周岁以下的未成年人，在使用我们的产品与/或服务前，应事先取得您监护人的同意。本平台根据国家相关法律法规的规定保护未成年人的个人信息。<br><br>
          2、我们不会主动直接向未成年人收集其个人信息。对于经监护人同意而收集未成年人个人信息的情况，我们只会在受到法律允许、监护人同意或者保护未成年人所必要的情况下使用、共享、转让或披露此信息。<br><br>
          3、如果有事实证明未成年人并未取得监护人同意的情况下注册使用了我们的产品与/或服务，我们会与相关监护人协商，并设法尽快删除相关个人信息。<br><br>
          4、对于可能涉及的不满14周岁的儿童个人信息，我们进一步采取以下措施予以保障：<br>
          （1）对于收集到的儿童个人信息，我们除遵守本隐私政策关于用户个人信息的约定外，还会秉持正当必要、知情同意、目的明确、安全保障、依法利用的原则，严格遵循《儿童个人信息网络保护规定》等法律法规的要求进行存储、使用、披露，且不会超过实现收集、使用目的所必须的期限，到期后我们会对儿童个人信息进行删除或匿名化处理。<br>
          （2）儿童或其监护人有权随时访问和更正儿童个人信息，还可以向我们提出更正和删除的请求。如您对儿童个人信息相关事宜有任何意见、建议或投诉、举报，请联系我们。我们会随时为您提供帮助。<br>
        </span>
      </p>

      <p><span class="p-font-size"><strong>七、本政策如何更新</strong></span></p>

      <p>
        <span class="p-font-size">
          我们的隐私政策可能变更。未经您明确同意，我们不会削减您按照本隐私政策所应享有的权利。我们会在本页面上发布对本政策所做的任何变更。<br><br>
          对于重大变更，我们还会提供更为显著的通知。本政策所指的重大变更包括但不限于：<br>
          1、我们的服务模式发生重大变化。如处理用户信息的目的、处理的用户信息类型、用户信息的使用方式等；<br>
          2、我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；<br>
          3、用户信息共享、转让或公开披露的主要对象发生变化；<br>
          4、您参与用户信息处理方面的权利及其行使方式发生重大变化；<br>
          5、我们负责处理用户信息安全的责任部门、联络方式及投诉渠道发生变化时；<br>
          6、用户信息安全影响评估报告表明存在高风险时。<br>
          我们还会将本政策的旧版本存档，供您查阅。
        </span>
      </p>

      <p><span class="p-font-size"><strong>八、如何联系我们</strong></span></p>

      <p>
        <span class="p-font-size">
          如果您对本隐私政策有任何疑问、意见或建议，通过以下方式与我们联系：<br><br>
          电子邮件：dsl1999@dslyy.com<br>
          电　　话：020-81284688<br>
          传　　真：020-81284688<br>
          我们设立了用户信息保护专职部门，您可以通过以下方式与相关人员联系，联系电话：020-81284688，一般情况下，我们将在三十天内回复。<br><br>
          如果您对我们的回复不满意，特别是我们的用户信息处理行为损害了您的合法权益您还可以向网信、电信、公安及工商等监管部门进行投诉或举报。
        </span>
      </p>

      <p>
        <span class="p-font-size">
          <strong>本隐私政策版本于2021年6月30日正式生效。</strong>
        </span>
      </p>

    </div>


  </div>

</template>

<script>
  export default {
    name: 'Privacy',
    data() {
      return {
        msg: 'Welcome to DSL'
      }
    }
  }
</script>

<style scoped>
  body {
    box-sizing: border-box;
    width: 100%;
    height: 100%;

  }

  div {
    /* border: 1px red solid; */
  }

  .page {
    padding: 2%;
    padding-bottom: 50px;
  }

  .header {
    width: 100%;
  }

  .content p {
    line-height: 20px;
  }

  .header-font-size {
    font-size: 25px;
  }

  .p-font-size {
    font-size: 15px;
  }

  .text-indent {
    text-indent: 20px;
  }

  .flex-col {
    display: flex;
    flex-direction: column;
  }

  .flex-row {
    display: flex;
    flex-direction: row;
  }

  .main-axis-center {
    justify-content: center;
  }

  .cross-axis-center {
    align-items: center;
  }

  .space-between {
    justify-content: space-between;
  }

  .select-version {}
</style>



// WEBPACK FOOTER //
// src/components/DslNotice.vue